import React from 'react';
import { grey600, CaptionText } from '@paypalcorp/pp-react';
import { StyleSheet, css } from 'aphrodite';

import getContent from 'pp-react-l10n';

const styles = StyleSheet.create({
  disclaimerWrapper: {
    maxWidth: 415,
    margin: '24px auto 0',
    '.ppvx_accordion__row': { border: 'none' },
  },
  disclaimer: {
    margin: 'auto',
  },
});

export default function VoucherFlowDisclaimer() {
  return (
    <div className={`voucher-disclaimer ${css(styles.disclaimerWrapper)}`}>
      <CaptionText
        style={{
          color: grey600,
        }}
      >
        {getContent('locals')('landing')('voucher.legal', null, {
          useHTML: true,
        })}
      </CaptionText>
    </div>
  );
}
